export enum MessagesEnum {
  CREATED = 'Invoice template created',
  UPDATED = 'Invoice template updated'
}
